// extracted by mini-css-extract-plugin
export default {"overlay":"taskView_overlay__WIBBc"};